import { v4 } from 'uuid';

import { PageSectionSource } from '@models/PageSection';
import { SOURCE_INSTANCE_ID } from '@models/PageSection';
import { DEFAULT_CHUNK_SIZE__COLLECTION_LIMIT } from '@utils/chunkSize';

const LEGACY_TITLE_KEY = 'TITLE_KEY';

const getLegacyTitleKey = (source: PageSectionSource) => {
  const legacyKey = source.params?.[LEGACY_TITLE_KEY as keyof typeof source.params];
  return typeof legacyKey === 'string' ? legacyKey : undefined;
};

export const getSourceInstanceId = (source: PageSectionSource) =>
  source[SOURCE_INSTANCE_ID] ?? getLegacyTitleKey(source) ?? source.sourceId;

export const withSourceInstanceId = (source: PageSectionSource): PageSectionSource => ({
  ...source,
  [SOURCE_INSTANCE_ID]: source[SOURCE_INSTANCE_ID] ?? getLegacyTitleKey(source) ?? v4(),
});

export const withNewSourceInstanceId = (source: PageSectionSource): PageSectionSource => ({
  ...source,
  [SOURCE_INSTANCE_ID]: v4(),
});

/**
 * Sets default source values based on type
 */
export const transformSectionSource = (source: PageSectionSource) => {
  const sourceWithInstanceId = withSourceInstanceId(source);

  switch (source.type) {
    case 'collection':
      return { ...sourceWithInstanceId, limit: DEFAULT_CHUNK_SIZE__COLLECTION_LIMIT };
    default:
      return sourceWithInstanceId;
  }
};

export const transformSectionSources = (sources: PageSectionSource[]) =>
  sources.map(source => transformSectionSource(source));
